export const modalBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  minWidth: 640,
};

export const previewStyles = {
  display: 'flex',
  gap: '16px',
  maxHeight: 380,
  minHeight: 160,
};

export const changesScrollStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  flex: 1,
  overflowY: 'auto',
  paddingRight: '8px',
};

export const footerStyles = {
  marginTop: '8px',
};
